import { useRef } from 'react'

import { useAppConfig, useProjectLogo } from '../../domains/config'

import { useDeviceLayout } from '../../shared/hooks/useDeviceLayout'
import { useFavorites } from '../../shared/hooks/useFavorites'

function normalizeDomIdSegment(value) {
  return String(value ?? 'runtime')
    .trim()
    .replace(/[^A-Za-z0-9_-]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'runtime'
}

export function useAppFoundationState() {
  const containerRef = useRef(null)
  const deviceLayout = useDeviceLayout(containerRef)
  const appConfig = useAppConfig()
  const { logoSrc } = useProjectLogo(appConfig.windowData?.projectDataUrl ?? null)
  const favorites = useFavorites(appConfig.windowData?.projectId)
  const appProjectId = appConfig.windowData?.projectId ?? null
  const domIdSuffix = normalizeDomIdSegment(appProjectId)
  const appRootId = `bim-cadaplus-app--${domIdSuffix}`
  const portalHostId = `bim-cadaplus-portals--${domIdSuffix}`

  return {
    containerRef,
    deviceLayout,
    appConfig,
    logoSrc,
    favorites,
    appProjectId,
    appRootId,
    portalHostId,
  }
}